
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const store = useStore()

    const onDocumentClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null
      if (target && target.classList.contains('sidebar-backdrop')) {
        store.commit({ type: 'updateSidebarVisible', value: false })
      }
    }

    onMounted(() => {
      document.addEventListener('click', onDocumentClick, true)
    })
    onBeforeUnmount(() => {
      document.removeEventListener('click', onDocumentClick, true)
    })

    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
